/* ============================================
   IS MY CHILD A CANDIDATE — JS
   Source: Toothpillow Webpage Claude (external design)

   NOTE: initNav() and initFooterYear() from the original main.js are omitted —
   navigation and footer are provided by the marketing layout.

   NOTE: Dot indicators use CSS class toggling (.is-active) instead of img src
   swapping. This avoids asset pipeline path issues in the Rails/Webpack context.
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {
  initAboutCarousel();
  initLookForCarousel();
  initFamiliesSeeCarousel();
  initQuestions();
  initStateModal();
});


/* ─────────────────────────────────────────
   ABOUT ASSESSMENT CAROUSEL
   Targets: #aboutTrack, #aboutPrev, #aboutNext, #aboutDots .carousel-dot
───────────────────────────────────────── */
function initAboutCarousel() {
  const track   = document.getElementById('aboutTrack');
  if (!track) return;

  const dots    = document.querySelectorAll('#aboutDots .carousel-dot');
  const prevBtn = document.getElementById('aboutPrev');
  const nextBtn = document.getElementById('aboutNext');
  const total   = track.querySelectorAll('.about-assessment__slide').length;
  let current   = 0;

  function goTo(index) {
    current = Math.max(0, Math.min(index, total - 1));
    track.style.transform = `translateX(-${current * 100}%)`;

    // NOTE (new): toggle .is-active CSS class instead of swapping img src
    dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === current);
    });

    if (prevBtn) prevBtn.disabled = current === 0;
    if (nextBtn) nextBtn.disabled = current === total - 1;
  }

  prevBtn?.addEventListener('click', () => goTo(current - 1));
  nextBtn?.addEventListener('click', () => goTo(current + 1));

  dots.forEach((dot) => {
    dot.addEventListener('click', () => goTo(parseInt(dot.dataset.index, 10)));
  });

  // Touch swipe
  let touchStartX = 0;
  track.addEventListener('touchstart', (e) => {
    touchStartX = e.touches[0].clientX;
  }, { passive: true });
  track.addEventListener('touchend', (e) => {
    const dx = e.changedTouches[0].clientX - touchStartX;
    if (Math.abs(dx) > 50) goTo(dx < 0 ? current + 1 : current - 1);
  }, { passive: true });

  goTo(0);
}


/* ─────────────────────────────────────────
   LOOK FOR CAROUSEL (mobile only)
   Targets: #lookForGrid, #lookForPrev, #lookForNext, #lookForDots .carousel-dot
───────────────────────────────────────── */
function initLookForCarousel() {
  const grid    = document.getElementById('lookForGrid');
  if (!grid) return;

  const dots    = document.querySelectorAll('#lookForDots .carousel-dot');
  const prevBtn = document.getElementById('lookForPrev');
  const nextBtn = document.getElementById('lookForNext');
  const cards   = Array.from(grid.querySelectorAll('.look-for__card'));
  const total   = cards.length;
  let current   = 0;

  const mobileQuery = window.matchMedia('(max-width: 768px)');

  function goTo(index) {
    if (!mobileQuery.matches) return;
    current = Math.max(0, Math.min(index, total - 1));
    const offset = cards[current].offsetLeft;
    grid.style.transform = `translateX(-${offset}px)`;

    dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === current);
    });

    if (prevBtn) prevBtn.disabled = current === 0;
    if (nextBtn) nextBtn.disabled = current === total - 1;
  }

  mobileQuery.addEventListener('change', () => {
    if (!mobileQuery.matches) {
      grid.style.transform = '';
      current = 0;
    } else {
      goTo(current);
    }
  });

  prevBtn?.addEventListener('click', () => goTo(current - 1));
  nextBtn?.addEventListener('click', () => goTo(current + 1));

  dots.forEach((dot) => {
    dot.addEventListener('click', () => goTo(parseInt(dot.dataset.index, 10)));
  });

  // Touch swipe
  let touchStartX = 0;
  grid.addEventListener('touchstart', (e) => {
    touchStartX = e.touches[0].clientX;
  }, { passive: true });
  grid.addEventListener('touchend', (e) => {
    const dx = e.changedTouches[0].clientX - touchStartX;
    if (Math.abs(dx) > 50) goTo(dx < 0 ? current + 1 : current - 1);
  }, { passive: true });

  window.addEventListener('resize', () => {
    if (mobileQuery.matches) goTo(current);
  }, { passive: true });

  goTo(0);
}


/* ─────────────────────────────────────────
   FAMILIES SEE CAROUSEL (mobile only — full-slide)
   Targets: #familiesSeeGrid, #familiesSeePrev, #familiesSeeNext, #familiesSeeDots .carousel-dot
───────────────────────────────────────── */
function initFamiliesSeeCarousel() {
  const grid    = document.getElementById('familiesSeeGrid');
  if (!grid) return;

  const dots    = document.querySelectorAll('#familiesSeeDots .carousel-dot');
  const prevBtn = document.getElementById('familiesSeePrev');
  const nextBtn = document.getElementById('familiesSeeNext');
  const cards   = Array.from(grid.querySelectorAll('.families-see__card'));
  const total   = cards.length;
  let current   = 0;

  const mobileQuery = window.matchMedia('(max-width: 768px)');

  function goTo(index) {
    if (!mobileQuery.matches) return;
    current = Math.max(0, Math.min(index, total - 1));
    // Each card is 100% wide — shift by full-slide multiples
    grid.style.transform = `translateX(-${current * 100}%)`;

    dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === current);
    });

    if (prevBtn) prevBtn.disabled = current === 0;
    if (nextBtn) nextBtn.disabled = current === total - 1;
  }

  mobileQuery.addEventListener('change', () => {
    if (!mobileQuery.matches) {
      grid.style.transform = '';
      current = 0;
    } else {
      goTo(current);
    }
  });

  prevBtn?.addEventListener('click', () => goTo(current - 1));
  nextBtn?.addEventListener('click', () => goTo(current + 1));

  dots.forEach((dot) => {
    dot.addEventListener('click', () => goTo(parseInt(dot.dataset.index, 10)));
  });

  // Touch swipe
  let touchStartX = 0;
  grid.addEventListener('touchstart', (e) => {
    touchStartX = e.touches[0].clientX;
  }, { passive: true });
  grid.addEventListener('touchend', (e) => {
    const dx = e.changedTouches[0].clientX - touchStartX;
    if (Math.abs(dx) > 50) goTo(dx < 0 ? current + 1 : current - 1);
  }, { passive: true });

  window.addEventListener('resize', () => {
    if (mobileQuery.matches) goTo(current);
  }, { passive: true });

  goTo(0);
}


/* ─────────────────────────────────────────
   QUESTIONS ACCORDION
   Targets: .questions__item > .questions__btn
   NOTE: Uses CSS grid-rows trick for smooth open/close animation (no JS height measurement).
   aria-expanded drives both the icon rotation and the answer reveal via CSS.
───────────────────────────────────────── */
/* ─────────────────────────────────────────
   STATE SELECTION MODAL
   Targets: #ctaModal, .open-cta-modal, .close-modal
───────────────────────────────────────── */
function initStateModal() {
  const modal = document.getElementById('ctaModal');
  if (!modal) return;

  const closeButtons = modal.querySelectorAll('.close-modal');

  document.querySelectorAll('.open-cta-modal').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      modal.classList.remove('hidden');
    });
  });

  closeButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      modal.classList.add('hidden');
    });
  });

  // Close on backdrop click
  modal.addEventListener('click', (e) => {
    if (e.target === modal || e.target.classList.contains('is-candidate-modal__backdrop')) {
      modal.classList.add('hidden');
    }
  });
}


function initQuestions() {
  const items = document.querySelectorAll('.questions__item');
  if (!items.length) return;

  items.forEach((item) => {
    const btn = item.querySelector('.questions__btn');
    if (!btn) return;

    btn.addEventListener('click', () => {
      const isExpanded = btn.getAttribute('aria-expanded') === 'true';

      // Close all others
      items.forEach((other) => {
        const otherBtn = other.querySelector('.questions__btn');
        if (otherBtn && otherBtn !== btn) {
          otherBtn.setAttribute('aria-expanded', 'false');
        }
      });

      btn.setAttribute('aria-expanded', String(!isExpanded));
    });
  });
}
